import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {articlesList_template} from "../components/templates/articlesList_template";

import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

let chartDiv;

export class articles extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected articlesList: articlesList_template;
    protected pagination: pagination_template;
    protected timer;
    protected viewPageUrl;

    private csvFileSummary: XMLHttpRequest | null = null;
    protected csvFileUpload : XMLHttpRequest | null = null;
    protected getModuleName(): string{

        return "articles";
    }

    buildContent(): Array<Element>{

        // create the article list
        this.articlesList = new articlesList_template("list", this.viewModel, this);
        this.template = this.articlesList;

        this.articlesList.setAddButtonShown(false);
        this.viewPageUrl = '/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/view-old/';


        let fullEmakiBrands = ["22", "21", "13", "4", "9", "14", "20", "11", "1", "23", "24", "26", "5", "7", "6", "27", "28", "29", "30", "31", "32", "33", "36", "40","41", "42", "2", "43", "44", "48", "49", "50", "51", "52"];

        if( fullEmakiBrands.indexOf(this.getVnAppZone().app.params.idBrand) > -1){
            this.articlesList.setAddButtonShown(true);
            this.viewPageUrl = '/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/view/';
        }

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Articles List");

        return [this.articlesList.build()];
    }

    public fillPage() : void{

        this.articlesList.buildDatePickerCalendar();
        this.getListFormData();
    }


    public  getListFormData(): void{

        if( "getListFormData" in this.XHRHdls ){
            this.XHRHdls["getListFormData"].cancelAndReset();
        }

        this.loadingIn(this.articlesList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON({articleContext: 'list'})]);
        this.XHRHdls['getListFormData'] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdls['getListFormData'].onReadyStateFunction = this.onListFormDataRequestReturn;
        this.XHRHdls['getListFormData'].execute();

    }

    protected onListFormDataRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                let statuses = [];
                for( let status of responseParsed.statuses){
                    if(status.id != 8){
                        statuses.push(status)
                    }
                }
                obj.articlesList.setStatusFilterItems(statuses);
                obj.articlesList.setIntentFilterItems(responseParsed.intents);
                obj.articlesList.setPaymentCategoryFilterItems(responseParsed.postPaymentCategory);
                obj.articlesList.setArticleTemplateFilterItems(responseParsed.articleTemplate);
                obj.articlesList.setPublishStatusFilterItems(responseParsed.publishStatuses);
                obj.articlesList.setSyncStatusFilterItems(responseParsed.syncStatuses);
                obj.articlesList.setTemplateFilterItems(responseParsed.templates);
                obj.articlesList.setClassificationFilterItems(responseParsed.classification);
                obj.articlesList.setNetworkCategoryFilterItems(responseParsed.groupCategory);
                obj.articlesList.setContentTypeFilterItems(responseParsed.contentType);
                obj.articlesList.setCategoryFilterItems(responseParsed.categories);
                obj.articlesList.setPermissions(responseParsed.permissions);
                obj.articlesList.setBrand(responseParsed.brand);

                obj.loadingOut(obj.articlesList.builtTemplate.children.namedItem("list-results"));
                obj.updateViewModelFromPath();

                obj.getSearchPresetsListData();
            });

       }
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.articlesList.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.articlesList.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected addArticle(){
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
        this.saveViewModule(this.getMemoryViewModel());
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/add/')
    }

    protected viewArticle(id){
        this.saveViewModule(this.getMemoryViewModel());
        let viewUrl = window.location.origin+this.viewPageUrl+id;
        let editUrl = window.location.origin + '/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/edit/' + id
        this.savePreviousPage(viewUrl, window.location.href);
        this.savePreviousPage(editUrl, window.location.href);
        page(this.viewPageUrl+id)
    }

    protected previewArticle(article, brand){

        let origin = document.location.origin;
        let brandDomain = brand.domain;
        let formReq_params: Array<Array<string>> = [];
        if(!origin.includes("https://emakicms.com")){
            brandDomain = brandDomain.replace("www.","");
        }
        //let url = origin.replace("emakicms.com",brandDomain) + '/preview/' + article.id + '/';
        let url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/article/previewNoSave/'+article.id+'/';
        formReq_params.push(["data", "None"]);
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(url,formReq_params, this);
        //using post to avoid data size limitation of GET
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onPreviewReturn;
        XHRHdl.execute();
    }

    protected onPreviewReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.openArticlePreview(responseParsed, false);
            });

            obj.loadingOut(obj.articlesList.builtTemplate);
        }
    }
    protected openArticlePreview(data, isAmp = false) {
        let origin = document.location.origin;
        let brandDomain = data.data.brand.domain;
        if(!origin.includes("https://emakicms.com")){
            brandDomain = brandDomain.replace("www.","");
        }

        let url = origin.replace("emakicms.com",brandDomain) + '/preview/' + data.data.emakiPreview.id + '/';

        if(url.includes("mig1")){
            url = url.replace("mig1", "ads");
        }

        if(url.includes("mig3")){
            url = url.replace("mig3", "qa7");
        }

        if(url.includes("mig4")){
            url = url.replace("mig4", "qa1");
        }
        if(url.includes("mig2")){
            url = url.replace("mig2", "qa8");
        }

        if(url.includes("www.thegearloop.com") && origin.includes("https://emakicms.com")){
            url = url.replace("www", "ads");
        }

        if (isAmp){

            url = url + 'amp/';
        }

        var f = document.createElement('form');
        f.action = url;
        f.method = 'POST';
        f.target = '_blank';

        var i = document.createElement('input');
        i.type = 'hidden';
        i.name = 'token';
        i.value = 'PWjvmuQqaq`;33}4';
        f.appendChild(i);

        var c = document.createElement('input');
        c.type = 'hidden';
        c.name = 'content';
        //c.value = this.articlesEdit.getContentTypeToPreview();
        f.appendChild(c);

        //if an emakiPreview was created, then add it so the brand site can read it. Otherwise add nothing so the brand site can read from DB instead.
        if (data.data.emakiPreview){

            var c = document.createElement('input');
            c.type = 'hidden';
            c.name = 'article';
            c.value = JSON.stringify(data.data.emakiPreview);
            f.appendChild(c);
        }

        document.body.appendChild(f);
        f.submit();
        document.body.removeChild(f);
    }

    protected viewArticleOnSite(article, brand){

        let origin = document.location.origin;
        let brandDomain = brand.domain;
        if(!origin.includes("https://emakicms.com")){
            brandDomain = brandDomain.replace("www.","");
        }
        let url = origin.replace("emakicms.com",brandDomain) + article.permalink;

        if(url.includes("mig1")){
            url = url.replace("mig1", "ads");
        }

        if(url.includes("mig3")){
            url = url.replace("mig3", "qa7");
        }

        if(url.includes("mig4")){
            url = url.replace("mig4", "qa1");
        }
        if(url.includes("mig2")){
            url = url.replace("mig2", "qa8");
        }

        let element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('target', '_blank');
        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    protected previewArticleAMP(article, brand){

        let origin = document.location.origin;
        let brandDomain = brand.domain;
        if(!origin.includes("https://emakicms.com")){
            brandDomain = brandDomain.replace("www.","");
        }
        let url = origin.replace("emakicms.com",brandDomain) + '/preview/' + article.id + '/amp';

        var f = document.createElement('form');
        f.action=url;
        f.method='POST';
        f.target='_blank';

        var i=document.createElement('input');
        i.type='hidden';
        i.name='token';
        i.value='PWjvmuQqaq`;33}4';
        f.appendChild(i);

        document.body.appendChild(f);
        f.submit();
        document.body.removeChild(f);
    }

    protected viewArticleOnSiteAMP(article, brand){

        let origin = document.location.origin;
        let brandDomain = brand.domain;
        if(!origin.includes("https://emakicms.com")){
            brandDomain = brandDomain.replace("www.","");
        }
        let url = origin.replace("emakicms.com",brandDomain) + article.permalink + "amp";

        let element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('target', '_blank');
        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    protected paginationOnPageClick(){

        this.filterList();
    }


    protected filterDateOnChange(){
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange(){
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
    }


    protected filterMultipleSelectorOnChange(){
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }


    protected articlesListReorder(){

        this.filterList();
    }

    protected filterSimpleOnChange(idElement){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.articlesList.builtTemplate.querySelector("#list-results-2"));
        this.articlesList.setPaginationIsVisible(false);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/getArticleReport/';
        this.timer = new Date().getTime();
        let subViewModel = this.articlesList.getViewModelForRequest();
        this.sendFilterCall(
            usrReq_url,
            subViewModel,
            this.onFilterRequestReturn,
            XMLHttpRequestHandler_requestType.GET,
            'articles',
            this.articlesList.builtTemplate.querySelector("#list-results-2"));

        // send a second request here for pagination
        let usrReq_url2: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/getArticleReportCount/';
        this.sendFilterCall(
            usrReq_url2,
            subViewModel,
            this.onFilterCountRequestReturn,
            XMLHttpRequestHandler_requestType.GET,
            'articles');
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });

            obj.loadingOut(obj.articlesList.builtTemplate.querySelector("#list-results-2"));
        }
    }

    protected onFilterCountRequestReturn(req, obj){
        return function(){
            obj.manageResponse(req, obj, function(){
                let responseParsed = JSON.parse(req.request.response);
                obj.updateCount(responseParsed);
            });
        }
    }

    protected updateList(responseParsed: any) {

        this.articlesList.setLockedArticles(responseParsed.lockItems);

        this.articlesList.setArticles(responseParsed.reportData.data);

        this.articlesList.onClickShowEditColumnPreferences(false);

        let execTime = Math.round((new Date().getTime() - this.timer)/1000*100)/100;
        this.articlesList.setExecutionTime(execTime);
    }

    protected updateCount(responseParsed: any) {
        let execTime = Math.round((new Date().getTime() - this.timer)/1000*100)/100;
        this.articlesList.setResultInfo(responseParsed.reportData.totalCount, responseParsed.reportData.totalPage,execTime );

        //Update the Paginator
        this.viewModel.list.pagination.itemCount(responseParsed.reportData.totalCount);
        this.articlesList.setPaginationIsVisible(true);
    }

    protected getMemoryViewModel(){

        let templateViewModel = this.articlesList.getTemplateViewModel();

        delete templateViewModel.articles;

        return templateViewModel;
    }

    protected getUsersSuggestion(keyword, idElement) {

        if( "getUsersSuggestion" in this.XHRHdls ){
            this.XHRHdls["getUsersSuggestion"].cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}, idElement: idElement};

        //let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getUsersSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getUsersSuggestion'].onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdls['getUsersSuggestion'].execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    if (responseParsed.data.users) {
                        if (responseParsed.data.idElement == "authorFilter") {
                            obj.articlesList.setAuthorFilter(responseParsed.data.users);
                        }else if (responseParsed.data.idElement == "editorFilter") {
                            obj.articlesList.setEditorFilter(responseParsed.data.users);
                        }else if (responseParsed.data.idElement == "ideatorFilter") {
                            obj.articlesList.setIdeatorFilter(responseParsed.data.users);
                        }
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                } else {
                    obj.articlesList.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.articlesList.deactivateLoading();
            }
        }

    }

    protected getTagsSuggestion(keyword, idElement) {

        if( "getTagsSuggestion" in this.XHRHdls ){
            this.XHRHdls["getTagsSuggestion"].cancelAndReset();
        }

        let subViewModel = {filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/tag/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getTagsSuggestion']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getTagsSuggestion'].onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdls['getTagsSuggestion'].execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.tags) {
                    let x = responseParsed.data.idElement;

                    obj.articlesList.setTagFilter(responseParsed.data.tags);
                }

            });
        }
    }

    // search preset section

    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.articlesList.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onPostSearchPresetArticles
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onPostSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.articlesList.addCreatedPresetToList(response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);

            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onPostFavoriteSearchPresetArticles
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onPostFavoriteSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);

            });

        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);
            });
        }
    }

    protected filterByUrl(){
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters){
        this.articlesList.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected setDefaultStatusFilters(){
        this.articlesList.setDefaultStatusFilters();
    }


    public getChartDiv(){
        return chartDiv;
    }

    protected getShortTermReport(idArticle) {

        if (this.XHRHdl) {

            this.XHRHdl.cancelAndReset();
        }

        chartDiv = document.getElementById("shortTermReportFormGroup");
        if(chartDiv){
            this.loadingIn(chartDiv);
        }

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/shortTermReport/get/' + idArticle;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", this.articlesList.getTemplateViewModel().shortTermReportRange()]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetShortTermReportReturn;
        this.XHRHdl.execute();
    }

    protected onGetShortTermReportReturn(req, obj) {
        return () => {
            obj.manageResponse(req, obj, () => {
                let responseParsed = JSON.parse(req.request.response,function (key, value) {
                    if (key == "date" || key == "publishDate" || key == "republishDate") {
                        return new Date(value);
                    } else {
                        return value;
                    }
                });
                obj.articlesList.setShortTermReport(responseParsed);
            });
            if(obj.getChartDiv()){

                obj.loadingOut(obj.getChartDiv());
            }
        }
    }

    protected editWatchlist(isAddToWatchlist, idArticle) {

        if (this.XHRHdl) {

            this.XHRHdl.cancelAndReset();
        }

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/editWatchlist/' + idArticle;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", isAddToWatchlist]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetAddedToWatchlist;
        this.XHRHdl.execute();
    }

    protected onGetAddedToWatchlist(req, obj) {
        return () => {
            if(req.request.status == 200){

                obj.manageResponse(req, obj, () => {

                    let responseParsed = JSON.parse(req.request.response);
                    obj.articlesList.setIsOnWatchlist(responseParsed);
                    if(responseParsed){
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Added to watchlist');
                    }else{
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Removed from watchlist');
                    }
                    obj.getVnAppZone().showNotificationToModule();
                });
            }else{

                let responseParsed = JSON.parse(req.request.response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, responseParsed.message);
                obj.getVnAppZone().showNotificationToModule();
            }

            obj.articlesList.getTemplateViewModel().watchlistButtonEnabled(true);
        }
    }

    /**
     * Retrieves the summary of trashed article files.
     *
     * @async
     * @returns {Promise<void>} A promise that resolves once the trashed article files summary is retrieved.
     */
    async getTrashedArticlesFilesSummary(): Promise<void> {
        try {
            const data = await this.trashArticlesSummaryRequest()
            this.articlesList.getTemplateViewModel().trashedArticlesSummary(data)
        } catch (e) {
            const {validations} = e
            if(validations && validations[0].messages){
                const errorMessages = validations[0].messages || ['An error occurs during the summary request']
                this.articlesList.setTrashedArticleFormErrorMessage(errorMessages);
            }
        }
    }

    /**
     * Uploads trashed articles files.
     *
     * @async
     * @returns {Promise<void>} A promise that resolves when the upload is successful or rejects with an error.
     */
    async uploadTrashedArticlesFiles(): Promise<void>{
        try {
            await this.trashArticlesUploadRequest()
            this.articlesList.toggleTrashedArticlesForm()
        } catch (e) {
            const {validations} = e
            if(validations && validations.messages) {
                const {validations} = e
                if(validations && validations[0].messages){
                    const errorMessages = validations[0].messages || ['An error occurs during the upload request']
                    this.articlesList.setTrashedArticleFormErrorMessage(errorMessages);
                }
            }
        }
    }

    /**
     * Creates and returns a new FormData object containing the files from the trashedArticlesFiles array.
     * @returns {FormData} - The FormData object with the appended files.
     */
    private prepareFormData = (): FormData => {
        const files = this.articlesList.getTemplateViewModel().trashedArticlesFiles();
        const formData = new FormData();
        for (const file of files) {
            formData.append('csvFiles[]', file);
        }
        return formData;
    }

    /**
     * Requests the summary of trash articles from the server.
     *
     * @returns {Promise<any>} - A promise that resolves with the response from the server, or rejects with an error message.
     */
    private trashArticlesSummaryRequest = (): Promise<any> => {
        return new Promise((resolve, reject) => {
            const idBrand = this.getVnAppZone().app.params["idBrand"];
            let url: string = `/api/brand/${idBrand}/trash/files/summary/`;
            this.csvFileSummary = new XMLHttpRequest()
            this.csvFileSummary.responseType = 'json'
            this.csvFileSummary.open("POST", url)
            this.csvFileSummary.onload = () => {
                const response = this.csvFileSummary!.response
                if (this.csvFileSummary!.readyState === 4 && this.csvFileSummary!.status === 200) resolve(response)
                else reject(response)
            }
            this.csvFileSummary.onloadstart = () => {
                this.articlesList.getTemplateViewModel().trashedArticlesFormIsLoading(true)
            }
            this.csvFileSummary.onloadend = () => {
                this.articlesList.getTemplateViewModel().trashedArticlesFormIsLoading(false)
            }
            this.csvFileSummary.onerror = () => {
                reject({message : 'An unexpected error occurs !'})
            }
            this.csvFileSummary.send(this.prepareFormData())
        });
    }

    /**
     * Uploads trash articles using a CSV file.
     * @returns {Promise<any>} - A Promise that resolves with the response if successful, or rejects with the response if an error occurred.
     */
    private trashArticlesUploadRequest = (): Promise<any> =>{
        return new Promise((resolve, reject) => {
            const idBrand = this.getVnAppZone().app.params["idBrand"];
            let url: string = `/api/brand/${idBrand}/trash/files/upload/`;
            this.csvFileUpload = new XMLHttpRequest()
            this.csvFileUpload.responseType = 'json'
            this.csvFileUpload.open("POST", url)
            this.csvFileUpload.onload = () => {
                const response = this.csvFileUpload!.response
                if (this.csvFileUpload!.readyState === 4 && this.csvFileUpload!.status === 200) resolve(response)
                else reject(response)
            }
            this.csvFileUpload.onloadstart = () => {
                this.articlesList.getTemplateViewModel().trashedArticlesFormIsLoading(true)
            }
            this.csvFileUpload.onloadend = () => {
                this.articlesList.getTemplateViewModel().trashedArticlesFormIsLoading(false)
            }
            this.csvFileUpload.onerror = () => {
                reject('Error occurred during the request.')
            }
            this.csvFileUpload.send(this.prepareFormData())
        })
    }

    /**
     * Abort the CSV summary request if it is in progress.
     *
     * @function abortCsvSummaryRequest
     */
    public abortCsvSummaryRequest = () => {
        if(this.csvFileSummary){
            this.csvFileSummary.abort();
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/articles.ts